<template>
  <div class="kefu"></div>
</template>

<script>
export default {
  watch: {
    $route: "handlePath",
  },

  mounted() {
    this.handlePath();
  },

  methods: {
    handlePath() {
      let { name } = this.$route;
      if (this.$config.KEFU_WHITE.includes(name)) {
        this.kefu(window, document, "script", "_MEIQIA");
        _MEIQIA("entId", "992c99be53dde2b65699121faea4dd74");
      } else {
        this.kefu(window, document, "script", "_MEIQIA");
        _MEIQIA();
      }
    },

    kefu(a, b, c, d, e, j, s) {
      a[d] =
        a[d] ||
        function () {
          (a[d].a = a[d].a || []).push(arguments);
        };
      (j = b.createElement(c)), (s = b.getElementsByTagName(c)[0]);
      j.async = true;
      j.charset = "UTF-8";
      j.src = "https://static.meiqia.com/widget/loader.js";
      s.parentNode.insertBefore(j, s);
    },
  },
};
</script>
